// extracted by mini-css-extract-plugin
export default {"wrapper":"DefaultLayout_wrapper__tkNS0","container":"DefaultLayout_container__NgAo7"};